import { commonWebSocket } from '@services/common/common.constants';
import { ISubscription } from '@app-types/websocket/subscription.types';
import { createReducer } from 'redux-act';

const defaultState = {
  subscriptions: new Array<ISubscription>(),
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.snapshot.SUBSCRIPTION_SNAPSHOT, (state:any, payload:any) => {
    if (Array.isArray(payload?.subscriptions)) {
      return {
        ...state,
        subscriptions: payload.subscriptions.filter((subscription: any) => subscription && typeof subscription === "object"),
      };
    }
    return state;
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/subscription/subscription.reducer.ts